import template from './document.paged-document.html';
import page from './page/documents.page.js';
import auditTrial from './audit-trial/page.audit-trial.js';

export default angular
  .module('doxy.realtime.components.teleconsent.action.paged-document', [
    page,
    auditTrial,
  ])
  .component('pagedDocument', {
    //paged-document
    template,
    bindings: {
      document: '<',
      me: '<',
      innerMediator: '<',
      onFinalize: '&',
    },
    controller: function ($rootScope, $timeout) {
      let scrollElement = null;

      const getScrollElement = () => {
        if (scrollElement) return scrollElement;
        return (scrollElement = angular.element(
          document.querySelector('.sidebar__box--main')
        ));
      };

      this.$onInit = () => {
        // Ensure document and pages are available before accessing them
        if (!this.document || !this.document.pages) {
          console.warn('PagedDocument: document or pages not available');
          return;
        }

        this.firstPageIndex = 0;
        this.lastPageIndex = this.document.pages.length - 1;
        this.currentPageIndex = this.firstPageIndex;

        // Ensure innerMediator is available before setting up event listeners
        if (this.innerMediator && typeof this.innerMediator.on === 'function') {
          this.innerMediator.on('navigate:get', (message) => {
            this.currentPageIndex = message.index;
            updateMenu();
          });
        } else {
          console.warn('PagedDocument: innerMediator not available or missing on method');
        }
        this.firstPageIndex = 0;
        this.lastPageIndex = this.document.pages.length - 1;
        this.currentPageIndex = this.firstPageIndex;
      };

      const updateMenu = () => {
        $rootScope.$emit('tcDocument:menu:set', this.currentPageIndex);
      };

      this.nextPage = () => {
        $timeout(() => {
          this.currentPageIndex++;
          this.innerMediator.emit('navigate', { index: this.currentPageIndex });
          updateMenu();
          getScrollElement().scrollTop(0);
        });
      };

      this.prevPage = () => {
        $timeout(() => {
          this.currentPageIndex--;
          this.innerMediator.emit('navigate', { index: this.currentPageIndex });
          updateMenu();
          getScrollElement().scrollTop(0);
        });
      };

      this.finalizeDocument = () => {
        this.finalizePromise = this.onFinalize();
      };

      $rootScope.$on('tcDocument:menu:get', (_event, index) => {
        this.currentPageIndex = index;
        this.innerMediator.emit('navigate', { index: this.currentPageIndex });
        getScrollElement().scrollTop(0);
      });

      this.$onDestroy = () => {
        $rootScope.$emit('tcPagedDocument', null);
      };
    },
  }).name;
